import { Box, createTheme, ThemeProvider } from '@mui/material'
import React, {useState} from 'react'
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import IpTracker from './IpTracker'
import Navbar from './Navbar'

const App = () => {

  const [theme,setTheme] = useState('light')
  const darkTheme = createTheme({
    palette:{
      mode:theme
    }
  })
  return (
    <ThemeProvider theme={darkTheme}>
      <Box bgcolor={'background.default'} color={'text.primary'}>
        <BrowserRouter>
        <Navbar theme={theme} setTheme={setTheme} />
        <Routes>
          <Route path='/' element={<IpTracker />} />
        </Routes>
        </BrowserRouter>
      </Box>
    </ThemeProvider>
  )
}

export default App